import React from "react";
import { Link } from "gatsby";
import styled from "styled-components";
import Img from "gatsby-image";
import LinkButton from "./LinkButton";
import CallButton from "./CallButton";
import OverenaFirma from "./OverenaFirma";
import { useMediaQuery } from 'react-responsive';
import Ilustrace1 from "../../assets/img/ilustracePohreb1.svg";
import Ilustrace2 from "../../assets/img/ilustracePohreb2.svg";
import Ilustrace3 from "../../assets/img/ilustracePohreb3.svg";
import Ilustrace4 from "../../assets/img/ilustracepohreb4.svg";


const FeaturesInner = styled.div`
  ${props => props.isPruh && "background: #F3F1EC;"}
  ${props => props.isPruh && "padding: 60px 0px;"}

  margin: 70px auto;
  
  @media (max-width: 899px) {
    margin: 50px auto;
  }

  .vCemJsmeJini {
    margin: 0 auto;  
    width: calc(100% - 100px);

    @media (max-width: 899px) {
      width: calc(100% - 50px);
    }

    h2 {
      font-family: Ivar;
      font-size: 32px;
      color: #000000;
      text-align: center;
      margin-bottom: 80px;

      @media (max-width: 899px) {
        font-size: 25px;
        line-height: 35px;
        margin-bottom: 60px;
      }
    }
    
    .features {
      @media (min-width: 900px) {
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: baseline;
        max-width: 1150px;
      }

      .feature {
        margin: 0 auto;
        margin-top: 60px;
        max-width: 600px;

        &:first-child {
          @media (max-width: 900px) {
            ${props => props.isPruh && "margin-top: 0 !important;"}
          }
        }

        @media (min-width: 900px) {
          margin: 0;
          max-width: 340px;
          width: calc((100% - 50px)/3);
        }

        img {
          margin: 0 auto;
          display: block;
          margin-bottom: 20px;

          @media (min-width: 900px) {
            margin-bottom: 25px;
          }
        }

        h3 {
          font-family: Visuelt-Bold;
          font-size: 20px;
          color: #000000;
          text-align: center;
          margin-bottom: 15px;
        }

        p {
          font-family: Visuelt-Regular;
          font-size: 16px;
          color: #585858;
          text-align: center;
          line-height: 25px;

          a {
            color: #585858;
          }
        }
      }
    }
  }
  
`;



const Features = ({
  isPruh,
  liteVerze,
  customH2,
  text1,
  text2,
  text3,
}) => {
  const isLess1000 = useMediaQuery({
    query: '(max-width: 1000px)'
  });

  const isLess899 = useMediaQuery({
    query: '(max-width: 899px)'
  });


  return (
    <FeaturesInner isPruh={isPruh}>
      <section className="vCemJsmeJini">
        {!isPruh &&
          <h2>{customH2 ? customH2 : "V čem jsme jiní než ostatní pohřební služby?"}</h2>
        }
        <div className="features">
          <div className="feature">
            <img src={Ilustrace3} alt="Vše vyřešíme přes internet" />
            <h3>{liteVerze ? "Jsme vám k dispozici" : "Vše vyřešíme přes internet"}</h3>
            {/* <p>Náš tým je tu pro vás 24 hodin denně, 7 dní v týdnu. Ať už potřebujete cokoliv. Uděláme, co bude v našich silách.</p> */}
            <p>{text1 ? text1 : "S námi celý pohřeb naplánujete z bezpečí domova. Nemusíte nikam chodit. Vše si můžete v klidu rozmyslet a poradit se s rodinou."}</p>
          </div>
          <div className="feature">
            <img src={Ilustrace2} alt="Vždy za transparentní ceny" />
            <h3>Vždy za transparentní ceny</h3>
            <p>{text2 ? text2 : "Cena, na které se s naší pohřební službou domluvíte, je vždy konečná. Obsahuje kompletně vše, co budete potřebovat."}</p>
          </div>
          {/* <div className="feature">
            <img src={Ilustrace1} alt="Urnu osobně doručíme" />
            <h3>Urnu vám osobně doručíme</h3>
            <p>Pro urnu si nemusíte chodit. My osobně vám ji přivezeme. Bezpečně a tam, kam budete potřebovat.</p>
          </div> */}

          <div className="feature">
            <img src={Ilustrace4} alt="Poskytneme vám speciální péči" />
            <h3>{liteVerze ? "Spolupráce s ověřeným partnerem" : "Poskytneme vám speciální péči"}</h3>
            <p>{text3 ? text3 : "O vše se postaráme za vás: vyřízení dokumentů na matrice, osobní doručení urny nebo převod digitálních účtů vašeho blízkého."}</p>
          </div>
        </div>
      </section>
    </FeaturesInner>
  );
}

export default Features;


